export default "__VITE_ASSET__DcnOEUti__"